import React from 'react'
import AppBadge from './app-badge'

const SEVERITY_MAP = {
  critical: { variant: 'danger', className: 'text-danger' },
  high: { variant: 'high', className: 'text-danger' },
  medium: { variant: 'warning', className: '' },
  low: { variant: 'secondary', className: '' }
}

function SeverityBadge({ severity, count, displayCount = true }) {
  const config = SEVERITY_MAP[severity] || { variant: null, className: 'text-secondary' }

  return (
    <AppBadge
      variant={config.variant}
      className={`text-center ${config.className} fw-normal`.trim()}
      style={{ cursor: 'help' }}
      data-testid={'severity-badge'}
    >
      {`${severity.charAt(0).toUpperCase() + severity.slice(1)}`}
    </AppBadge>
  )
}

export default SeverityBadge
